/* eslint-disable import/no-cycle */
/* eslint-disable camelcase */
import {
	reset,
	setItems,
	setIsLoadingIsLoaded,
	setErrorMessage,
	clearErrorMessage,
} from './actions';
import initialState from './initialState';

// ************
// PARTS
// ************
const reducerParts = {
	[reset]: state => {
		return {
			...state,
			...initialState
		};
	},
	[setItems]: (state, { payload: { items = [], serverItems = [] } }) => {
		return {
			...state,
			items: [...items],
			serverItems: [...serverItems],
		};
	},
	[setIsLoadingIsLoaded]: (state, { payload: { isLoading, isLoaded } }) => {
		return {
			...state,
			isLoading,
			isLoaded,
		};
	},
	[setErrorMessage]: (state, { payload: { message } }) => {
		return {
			...state,
			errorMessage: message
		};
	},
	[clearErrorMessage]: state => {
		return {
			...state,
			errorMessage: undefined
		};
	}
};

export default reducerParts;
